import {
  css
} from 'lit';

export const SkipToMainStyle = css`
.lds-skip-to-main {
  position: relative;
  font-size: var(--lds-typography-skip-to-main-font-size);
  background-color: var(--lds-color-skip-to-main-background);
}
.lds-skip-to-main.side-nav {
  padding-left: var(--lds-spacing-skip-to-main-side-nav-padding-left);
}
.lds-skip-to-main .lds-skip-placeholder {
  padding-top: 0;
  transition: .35s ease padding-top;
}
.lds-skip-to-main .lds-skip-link {
  position: absolute;
  display: block;
  padding: var(--lds-spacing-skip-to-main-padding);
  margin: var(--lds-spacing-skip-to-main-margin);
  color: var(--lds-color-skip-to-main);
  box-shadow: var(--lds-shadow-skip-to-main);
  border: 1px solid var(--lds-color-skip-to-main);
  border-radius: var(--lds-spacing-025);
  text-decoration: none;
  line-height: 1rem;
  transform: translateY(-225%);
  transition: .35s ease transform;
}
.lds-skip-to-main .lds-skip-link:focus {
  text-decoration: none;
  outline: none;
  transform: translateY(0);
}
.lds-skip-to-main .lds-skip-link:focus + .lds-skip-placeholder {
  padding-top: 2rem;
}
`;

export default SkipToMainStyle;
